const generateCacheKey = (...keys: string[]) => keys.join('/')

export const videoCallCacheKeys = {
  getVideoCallUsers: (videoCallUserUids: number[]) =>
    generateCacheKey('getVideoCallUsers', ...videoCallUserUids.map(String)),
}
